import { buildURLData } from 'web-utility';

import { tvClient, TVData } from '../../../../model/service';
import { IHistoryProvider } from '../interface';

type ChartData = TVData<
  {
    conversionType: 'direct';
    conversionSymbol: number;
    time: number;
    low: number;
    high: number;
    open: number;
    close: number;
    volumefrom: number;
    volumeto: number;
  }[]
>;

export class ExampleHistoryProvider implements IHistoryProvider {
  async getBars(
    symbolInfo: { name: string },
    resolution: string | number,
    from: string | number,
    toTs: string | number = '',
    first,
    limit = 1000
  ) {
    const [fsym, tsym] = symbolInfo.name.split(/[:/]/);

    const url = `/data/histo${
      resolution === 'D' ? 'day' : resolution >= 60 ? 'hour' : 'minute'
    }`;
    const qs = {
      fsym,
      tsym,
      toTs,
      limit,
      aggregate: 1 //resolution
    };
    const {
      body: { Response, Message, Data }
    } = await tvClient.post<ChartData>(`${url}?${buildURLData(qs)}`);

    if (Response === 'Error') {
      console.error('CryptoCompare API error:', Message);
      return [];
    }
    if (!Data[0]) return [];

    const bars = Data.map(({ time, volumefrom, ...rest }) => ({
      time: time * 1000, //TradingView requires bar time in ms
      volume: volumefrom,
      ...rest
    }));
    if (first) history[symbolInfo.name] = { lastBar: bars[bars.length - 1] };

    return bars;
  }
}
